import { Avatar, Table, Tag } from "@jutro/ui";
import { ColumnDef } from "@tanstack/react-table";
import { envVars } from "envvars";
import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { SetContainerRef } from "components/AnimatedHeaderOnScrollWrapper/types";
import { EdmMedicalPerson } from "lib/graphql/megaSchema";
import { isMidwife, isNurse } from "lib/tools/auth";
import { avatarConfig } from "lib/tools/httpConfigs";
import { EmptySearchListIcon } from "views/StaffSchedule/StaffSettings/components/EmptySearchListIcon";
import { getStaffGenreLabel } from "views/StaffSchedule/StaffSettings/tools";

const columns: ColumnDef<EdmMedicalPerson>[] = [
  {
    id: "fullName",
    header: "Imię i nazwisko",
    cell: ({ row }) => {
      const { id, name } = row.original;
      return (
        <div className="flex gap-3">
          <Avatar
            type="photo"
            imgSrc={`${avatarConfig[envVars.REACT_APP_CONFIG]}/${id}`}
          />
          <span className="font-label">{name}</span>
        </div>
      );
    },
  },
  {
    id: "genre",
    accessorKey: "genre",
    header: "Stanowisko",
    cell: ({ row }) => {
      const staff = row.original;

      return (
        <div className="flex h-6 min-w-24 items-center">
          <Tag
            text={getStaffGenreLabel(staff)}
            color={isNurse(staff) || isMidwife(staff) ? "green" : "blue"}
          />
        </div>
      );
    },
  },
];

type Props = {
  filteredStaff: EdmMedicalPerson[];
  selectedStaff: EdmMedicalPerson | null;
  setSelectedStaff: Dispatch<SetStateAction<EdmMedicalPerson | null>>;
  setContainerRef: SetContainerRef;
};

export const StaffList = ({
  filteredStaff,
  selectedStaff,
  setSelectedStaff,
  setContainerRef,
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    setContainerRef(ref);
  }, [ref]);

  return (
    <>
      {filteredStaff.length ? (
        <div className="min-w-[560px]">
          <Table
            ref={ref}
            columns={columns}
            data={filteredStaff}
            selectionRowMode="single"
            selectedRow={selectedStaff}
            setSelectedRow={(row) => setSelectedStaff(row)}
          />
        </div>
      ) : (
        <div className="font-paragraph-0 flex h-full flex-col items-center justify-center gap-8 p-8 text-center">
          <EmptySearchListIcon />
          <div className="flex flex-col">
            <span>Ups, brak osób spełniających kryteria wyszukiwania.</span>
            <span>Spróbuj jeszcze raz</span>
          </div>
        </div>
      )}
    </>
  );
};
